import {
  ALLOWED_EMAILS,
  EMAIL_REGEX,
  HOTLINE_NUMBER,
  PHONE_REGEX,
  ALLOWED_URLS,
  URL_REGEX,
} from 'constants/constants';

export const removeAllowedUrls = (message: string) => {
  if (!message?.length) return { messageWithoutAllowedUrls: '', count: 0 };

  let messageWithoutAllowedUrls = message;
  ALLOWED_URLS.forEach((url) => {
    messageWithoutAllowedUrls = messageWithoutAllowedUrls.replaceAll(url, '');
  });

  return { messageWithoutAllowedUrls, count: (message.length - messageWithoutAllowedUrls?.length) };
};

export const checkPhoneOrEmailInMessage = (message: string) => {
  const regExpEmailAndPhone = new RegExp(
    `${EMAIL_REGEX.source}|${PHONE_REGEX.source}|${URL_REGEX.source}`,
    'gmi',
  );

  return message?.match(regExpEmailAndPhone);
};

export const checkPhoneOrEmailInMessageWithoutHotlineNumber = (
  message: string,
  isPsychic: boolean = true,
) => {
  if (!message) return [];

  const { messageWithoutAllowedUrls } = removeAllowedUrls(message);
  const phoneOrEmail = checkPhoneOrEmailInMessage(messageWithoutAllowedUrls);

  if (!phoneOrEmail?.length) return [];

  return phoneOrEmail.filter((raw) => {
    const sanitized = raw.replace(/[^A-Za-z0-9@.+_-]/g, '');
    const lower = sanitized.toLowerCase();

    const isEmail = EMAIL_REGEX.test(sanitized);

    if (isEmail) {
      return !(isPsychic && ALLOWED_EMAILS.includes(lower));
    }

    const digitsOnly = sanitized.replace(/[^0-9]/g, '');
    const isPhone = PHONE_REGEX.test(digitsOnly);

    if (isPhone) {
      return !(isPsychic && HOTLINE_NUMBER.includes(digitsOnly));
    }

    return true;
  });
};
